class FooterComponent extends HTMLElement {
    constructor() {
      super();
      document.addEventListener('contentfulLoaded', () => {
        this.handleConfigLoaded();
      });
    }
  
    handleConfigLoaded() {
      this.useContentful();
    }
  
    useContentful() {
      this.translations = window.contentfulTranslations;
      this.subscribeRef = this.translations.fields.reference5.fields;
      this.linksRef = this.translations.fields.reference6.fields;
      this.subfooterRef = this.translations.fields.reference7.fields;
      const footerEl = document.getElementById('Footer');
      
      footerEl.innerHTML += this.buildFooter();
    }
  
    renderShoppingWith() {
      return `
        <div class="display-grid gap--8 column--center md--column md--column--spaced">
          <div class="footer-col display-grid column--center md--column--start">
            <h4 class="mb--3">${this.linksRef.reference6.fields.item1}</h4>
            <span class="font--0">
              <img 
                alt="rep picture" 
                size="100" 
                src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='35' height='35'%3E%3Crect width='100%' height='100%' fill='%23ffffff' /%3E%3C/svg%3E"
                width="100" 
                height="100" 
                class="footer--avatar_img st_rep-info-picture_JS" 
                loading="lazy" 
                style="color: transparent; border-radius: 50%;"
              >
            </span>
            <p class="font--bold announcement-bar-consultant-name-JS nul_representative-alias_JS nul_representative-fullname_JS footer_sponsor"></p>
            <ol class="mt--2">
              <li class="column gap--1 column--center md--column--start row--center">
                <svg viewBox="0 0 512 512" width="24px" height="24px" class="icon--xsmall icon--white">
                  <path d="M511.2 387l-23.25 100.8c-3.266 14.25-15.79 24.22-30.46 24.22C205.2 512 0 306.8 0 54.5c0-14.66 9.969-27.2 24.22-30.45l100.8-23.25C139.7-2.602 154.7 5.018 160.8 18.92l46.52 108.5c5.438 12.78 1.77 27.67-8.98 36.45L144.5 207.1c33.98 69.22 90.26 125.5 159.5 159.5l44.08-53.8c8.688-10.78 23.69-14.51 36.47-8.975l108.5 46.51C506.1 357.2 514.6 372.4 511.2 387z"></path>
                </svg>
                <a class="font--inverse st_rep-info-phone-div_JS st_rep-info-phone_JS"></a>
              </li>
              <li class="column gap--1 column--center md--column--start row--center">
                <svg viewBox="0 0 512 512" width="24px" height="24px" class="icon--xsmall icon--white">
                  <path d="M464 64C490.5 64 512 85.49 512 112C512 127.1 504.9 141.3 492.8 150.4L275.2 313.6C263.8 322.1 248.2 322.1 236.8 313.6L19.2 150.4C7.113 141.3 0 127.1 0 112C0 85.49 21.49 64 48 64H464zM217.6 339.2C240.4 356.3 271.6 356.3 294.4 339.2L512 176V384C512 419.3 483.3 448 448 448H64C28.65 448 0 419.3 0 384V176L217.6 339.2z"></path>
                </svg>
                <a class="font--inverse st_rep-info-email_JS st_rep-info-email-div_JS"></a>
              </li>
            </ol>
          </div>
          <div class="footer-col font--center">
            <img 
              alt="company logo" 
              layout="intrinsic" 
              sizes="(min-width: 375px) 100vw, (min-width: 768px) 100vw, (min-width: 1024px) 100vw, (min-width: 1280px) 100vw" 
              srcset="https://newulife.com/images/New-u-life-logo-white.svg 350w, https://newulife.com/images/New-u-life-logo-white.svg 384w, https://newulife.com/images/New-u-life-logo-white.svg 750w, https://newulife.com/images/New-u-life-logo-white.svg 1200w" 
              src="https://newulife.com/images/New-u-life-logo-white.svg" 
              width="207" 
              height="87"
              loading="lazy" 
              style="color: transparent; height: auto; width: 100%;"
            >
            <ol>
              <li>${this.linksRef.reference6.fields.item2}</li>
            </ol>
          </div>
        </div>
      `
    }
  
    renderDefaultLinks() {
      return `
        <div class="footer-col-container display-grid gap--8 column--center md--column--stretch row--start lg--column lg--gap--8">
          <div class="footer-col font--center lg--font--left display-grid gap--1-5">
            <img 
              alt="New-u-life-logo-white" layout="intrinsic" sizes="(min-width: 375px) 100vw, (min-width: 768px) 100vw, (min-width: 1024px) 100vw, (min-width: 1280px) 100vw" 
              srcset="https://images.ctfassets.net/96ftuyamizgy/1V04uWyge6fS4RSpNSgUL1/f93e5c8d0e88ee7b6420a37ab5fe26ab/New-u-life-logo-white.svg 350w, https://images.ctfassets.net/96ftuyamizgy/1V04uWyge6fS4RSpNSgUL1/f93e5c8d0e88ee7b6420a37ab5fe26ab/New-u-life-logo-white.svg 384w, https://images.ctfassets.net/96ftuyamizgy/1V04uWyge6fS4RSpNSgUL1/f93e5c8d0e88ee7b6420a37ab5fe26ab/New-u-life-logo-white.svg 750w, https://images.ctfassets.net/96ftuyamizgy/1V04uWyge6fS4RSpNSgUL1/f93e5c8d0e88ee7b6420a37ab5fe26ab/New-u-life-logo-white.svg 1200w" 
              src="https://images.ctfassets.net/96ftuyamizgy/1V04uWyge6fS4RSpNSgUL1/f93e5c8d0e88ee7b6420a37ab5fe26ab/New-u-life-logo-white.svg" width="250" height="250" 
              decoding="async" 
              data-nimg="future" 
              class="footer-logo" 
              loading="lazy" 
              style="color: transparent; height: auto; width: 100%;"
            >
            <div class="display-grid gap--1-5 font--150">
              <ol>
                <li>${this.linksRef.text1}</li>
                <li>${this.linksRef.text2}</li>
              </ol>
            </div>
          </div>
          <div class="link-col-container display-grid md--column gap--8 md--gap--2 lg--gap--4 font--center md--font--left">
            <div class="footer-col">
              <h4 class="mb--2 font--primary-dark">${this.linksRef.reference1.fields.title}</h4>
              <ol id="link-list">
                <li><a href="${window.newULifeConfig.marketDomain}/leadership/">${this.linksRef.reference1.fields.listArray[0].fields.textString}</a></li>
                <li><a href="${window.newULifeConfig.marketDomain}/company/">${this.linksRef.reference1.fields.listArray[1].fields.textString}</a></li>
                <li><a href="${window.newULifeConfig.marketDomain}/mission-vision-values/">${this.linksRef.reference1.fields.listArray[2].fields.textString}</a></li>
                <li><a href="https://www.indeed.com/cmp/New-U-Life-380df4c7">${this.linksRef.reference1.fields.listArray[3].fields.textString}</a></li>
              </ol>
            </div>
            <div class="footer-col">
              <h4 class="mb--2 font--primary-dark">${this.linksRef.reference2.fields.title}</h4>
              <ol id="link-list">
                <li><a href="https://dash.newulife.com">${this.linksRef.reference2.fields.listArray[0].fields.textString}</a></li>
                <li><a href="${window.newULifeConfig.marketDomain}/support/">${this.linksRef.reference2.fields.listArray[3].fields.textString}</a></li>
              </ol>
            </div>
            <div class="footer-col">
              <h4 class="mb--2 font--primary-dark">${this.linksRef.reference3.fields.title}</h4>
              <ol id="link-list">
                <li><a href="${window.newULifeConfig.marketDomain}/events/">${this.linksRef.reference3.fields.listArray[0].fields.textString}</a></li>
                <li><a href="${window.newULifeConfig.marketDomain}/dream-it-trip-2024/">${this.linksRef.reference3.fields.listArray[1].fields.textString}</a></li>
                <li><a href="${window.newULifeConfig.marketDomain}/events/#pastevents">${this.linksRef.reference3.fields.listArray[2].fields.textString}</a></li>
              </ol>
            </div>
            <div class="footer-col">
              <h4 class="mb--2 font--primary-dark">${this.linksRef.reference4.fields.title}</h4>
              <ul class="social-network social-circle display-grid gap--1 md--gap--2">
                ${window.newULifeConfig.socialLinks.map(link => 
                  `<li>
                    <a href="${link.href}" title="${link.title}" class="s-icon">
                      <img alt="social-icon" src="${link.imgSrc}" width="250" height="250" decoding="async" loading="lazy" style="color: transparent; height: auto; width: 100%;">
                    </a>
                  </li>`
                ).join('')}
              </ul>
            </div>
          </div>
        </div>
      `;
    }
  
    buildFooter() {
      return `
        <footer id="footer" class="footer">
          <div 
            class="footer-links u-background" 
            style="background-image: url('https://newulife.com/images/big-u-icon.svg'), linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.1));"
          >
            <div class="page-width">
              <hr>
              ${window.newULifeConfig.als === '1' ? this.renderDefaultLinks() : this.renderShoppingWith()}
            </div>
          </div>
          <div class="footer-subfooter">
            <div class="page-width row lg--column lg--column--spaced column--center row--start gap--2">
              <div class="row row--center md--column column--center gap--2 md--gap--4 font--center">
                <a href="${window.newULifeConfig.marketDomain}/terms-and-conditions/">${this.subfooterRef.item1}</a>
                <a href="${window.newULifeConfig.marketDomain}/privacy-policy/">${this.subfooterRef.item2}</a>
                <a href="${window.newULifeConfig.marketDomain}/returns-and-cancellations/">${this.subfooterRef.item5}</a>
                <a href="${window.newULifeConfig.marketDomain}/shipping-policy/">${this.subfooterRef.item6}</a>
                <a class="hover:underline" href="https://shop-de.newulife.com/pages/eu-withdrawal-form?als=1">Right of Withdrawal</a>
              </div>
              <p>${this.subfooterRef.item4}</p>
            </div>
          </div>
        </footer>
      `;
    }
  }
  
  customElements.define('footer-component', FooterComponent);